import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/es/storage";

// Define the shape of the state
interface UrlParameterState {
	urlParameter: string;
}

// Initial state
const initialState: UrlParameterState = {
	urlParameter: "",
};

// Create the slice
const urlParameterSlice = createSlice({
	name: "urlParameter",
	initialState,
	reducers: {
		setUrlParameter(state, action: PayloadAction<string>) {
			state.urlParameter = action.payload;
		},
	},
});

// Persist configuration
const urlParameterPersistConfig = {
	key: "urlParameter",
	storage,
};

// Export persisted reducer
export const urlParameterReducer = persistReducer(urlParameterPersistConfig, urlParameterSlice.reducer);

// Export action
export const { setUrlParameter } = urlParameterSlice.actions;
